import { FilterCriteria } from "../../data/type";
import { compareBranchValues } from "../Common";

const traffic_type = [
    "車朝",
    "車昼",
    "車夜",
    "車夜（モバ空）",
    "車休祝日",
    "車休祝日（モバ空）",
    "人朝",
    "人朝特定",
    "人昼",
    "人昼特定",
    "人夜",
    "人夜（モバ空）",
    "人夕方特定",
    "人休祝日",
    "人夕方特定（モバ空）",
    "人休祝日（モバ空）" 
]

const counter = [
    'top_left_count',
    'top_bottom_count',
    'top_right_count',
    'right_top_count',
    'right_left_count',
    'right_bottom_count',
    'bottom_right_count',
    'bottom_top_count',
    'bottom_left_count',
    'left_bottom_count',
    'left_right_count',
    'left_top_count'
]

const count_type = [
    'top_left_type',
    'top_bottom_type',
    'top_right_type',
    'right_top_type',
    'right_left_type',
    'right_bottom_type',
    'bottom_right_type',
    'bottom_top_type',
    'bottom_left_type',
    'left_bottom_type',
    'left_right_type',
    'left_top_type'
]

const count_number = [
    '①',
    '②',
    '③',
    '④',
    '⑤',
    '⑥',
    '⑦',
    '⑧',
    '⑨',
    '⑩',
    '⑪',
    '⑫'
]

export const changeHistoryTableName = (tableNameMaster: any, table_physics_name: string, logData: any) => {
    let table_logic_name = table_physics_name
    tableNameMaster.map((row: any) => {
        if (row.table_physics_name === table_physics_name) {
            table_logic_name = row.table_logic_name
        }
    })
    
    // 調査種別は表紙ページに分類
    if (logData.target_table === "location_base" && logData.target_column === "location_type") {
        table_logic_name = "表紙";
    }

    if (table_physics_name === "location_trade_area") {
        const subKey = JSON.parse(
            logData.sub_key.includes("'")
            ? JSON.stringify(logData.sub_key).replaceAll('"', '').replaceAll("'", '\"')
            : logData.sub_key
        )
        if ("town_district" in subKey) {
            table_logic_name = table_logic_name + "　" + subKey.town_district
        }
    }

    if (logData.target_table === "location_traffic" || logData.target_table === "通行量") {
        try {
            const subKey = JSON.parse(
                logData.sub_key.includes("'")
                ? JSON.stringify(logData.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                : logData.sub_key
            )

            // 文字列を数値に変換
            const trafficType = subKey.traffic_type != null ? parseInt(subKey.traffic_type) : null;
            const trafficTypeSeq = subKey.traffic_type_seq != null ? parseInt(subKey.traffic_type_seq) : null;

            // 数値変換後の判定
            if (trafficTypeSeq != null && !isNaN(trafficTypeSeq) && trafficType != null && !isNaN(trafficType)) {
                table_logic_name = table_logic_name + "<br>" + traffic_type[trafficType] + "　" + trafficTypeSeq + "行目";
            } else if (trafficType != null && !isNaN(trafficType)) {
                table_logic_name = table_logic_name + "<br>" + traffic_type[trafficType];
            } 
        } catch (e) {}
    }

    if (table_physics_name === "location_conflict") {
        try {
            const subKey = JSON.parse(
                logData.sub_key.includes("'")
                ? JSON.stringify(logData.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                : logData.sub_key
            )
            // conflict_typeの表示
            if (subKey.conflict_type === "0" || subKey.conflict_type === "1") {
                table_logic_name = table_logic_name + "（CVS）";
            } else if (subKey.conflict_type === "2" || subKey.conflict_type === "3") {
                table_logic_name = table_logic_name + "（SMDS）";
            }
            // 店舗名の表示
            if (subKey.tenpo_name) {
                table_logic_name = table_logic_name + "<br>" + subKey.tenpo_name;
            }
        } catch (e) {}
    }

    // 影響度基本項目の処理（location_impact）
    // sub_key : { tenpo_name: "店舗名" }
    // 表示形式: "影響度\n店舗名"
    if (table_physics_name === "location_impact") {
        try {
            const subKey = JSON.parse(
                logData.sub_key.includes("'")
                ? JSON.stringify(logData.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                : logData.sub_key
            )
            if (Object.keys(subKey).indexOf("tenpo_name") !== -1) {
                table_logic_name = table_logic_name + "<br>" + subKey.tenpo_name
            }    
        } catch (e) {}
    }

    // 影響度カウンター項目の処理（location_impact_counter）
    // sub_key: { tenpo_name: "店舗名", route: "ルート名", intersection: "交差点名", route_seq: "順序番号" }
    // 表示形式: "影響度カウンター\nルート名\n交差点名"
    if (logData.target_table === "location_impact_counter") {
        try {
            const subKey = JSON.parse(
                logData.sub_key.includes("'")
                ? JSON.stringify(logData.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                : logData.sub_key
            )
            const tenpoName = subKey.tenpo_name || "";
            const route = subKey.route || "";
            const intersection = subKey.intersection || "";

            if (tenpoName) {
                table_logic_name = table_logic_name + "<br>" + tenpoName;
            }
            if (route) {
                table_logic_name = table_logic_name + "<br>" + route;
            }
            if (intersection) {
                table_logic_name = table_logic_name + "<br>" + intersection;
            }
        } catch (e) {}
    }

    return table_logic_name.replaceAll("<br>", "\n")
}

export const changeHistoryColumnName = (tableNameMaster: any, column_physics_name: string, logData: any) => {
    let column_logic_name = column_physics_name
    tableNameMaster.map((row: any) => {
        if (row.column_physics_name === column_physics_name && 
            row.table_physics_name === logData.target_table) {
            column_logic_name = row.column_logic_name
        }
    })

    if (logData.target_table === "location_base" && logData.target_column === "location_type") {
        column_logic_name = "調査種別";
    }

    if (logData.target_table === "location_impact_counter") {
        if (counter.includes(logData.target_column)) {
            // カウント
            column_logic_name = column_logic_name + (count_number[counter.indexOf(logData.target_column)])
        } else if (count_type.includes(logData.target_column)) {
            // カウントタイプ
            column_logic_name = column_logic_name + (count_number[count_type.indexOf(logData.target_column)])
        }
    }
    // 改行置換
    return column_logic_name.replaceAll("<br>", "\n")
}


export const changeHistorySelecterDisplay = (codeMaster: any, key: string, code_value: string) => {
    let code_display = code_value
    let search_key = key
    // common系の場合検索キーの変更
    if ([
        'handle_category_tobacco',
        'handle_category_liquor'
    ].includes(search_key)) {
        search_key = 'marubatu'
    } else if ([
            'handle_category_parking',
            'conflict_median_strip',
            'cut_survey',
        ].includes(search_key)) {
            search_key = 'common_yesnone_kana'
    } else if ([
            'median_strip_select',
            'median_strip_select2',
            'median_strip_select3',
            'median_strip_select4',
            'sidewalk_select',
            'sidewalk_select2',
            'sidewalk_select3',
            'sidewalk_select4',
            'traffic_signal_etc_forward_select',
            'traffic_signal_etc_forward_select2',
            'traffic_signal_etc_forward_select3',
            'traffic_signal_etc_forward_select4',
            'traffic_signal_etc_front_location_select',
            'traffic_signal_etc_front_location_select2',
            'traffic_signal_etc_front_location_select3',
            'traffic_signal_etc_front_location_select4',
        ].includes(search_key)) {
            search_key = 'common_yesnone'
    } else if ([
            'plan_area_shared_road',
            'conflict_shared_road',
        ].includes(search_key)) {
            search_key = 'common__shared_road'
    } else if ([
            'car_another_survey',
            'people_another_survey',
        ].includes(search_key)) {
            search_key = 'separate_investigation'
    } else if ([
            'others_facility_1',
            'others_facility_2',
            'others_facility_3',
            'others_facility_4',
        ].includes(search_key)) {
            search_key = 'others_facility'
    } else if (count_type.includes(search_key)) {
            search_key = 'impact_count_type'
    }
    if (codeMaster) {
        if (codeMaster[search_key] && code_value !== '' && code_value !== undefined) {
            codeMaster[search_key].filter((row: any) => {
                if (row.code_value === code_value.toString()) {
                    code_display = row.code_display
                }
            })
        }
    }

    return code_display.replaceAll("<br>", "\n")
}

// ページグループ化とソートのためのpage_sort値とcolumn_sort値をデータに付与する関数
// テーブル名とcodeMaster.page_filterを照合し、完全一致→部分一致の優先順位でソート順序を決定
// パフォーマンス最適化：事前計算されたtableLogicNameを使用
export const addSortData = (data: any[], codeMaster: any, tableNameMaster: any) => {
    if (!codeMaster?.page_filter || !Array.isArray(codeMaster.page_filter)) {
        return data;
    }

    return data.map((item: any) => {
        // 事前計算されたtableLogicNameを使用
        const tableName = item.tableLogicName;
        let pageSort = null;

        if (item.target_table === "location_traffic") {
            pageSort = "11"
        } else if (tableName.includes("競合店（CVS）")) {
            // 競合店舗の場合は強制的にpage_sortを設定
            pageSort = "17";
        } else if (tableName.includes("競合店（SMDS）")) {
            pageSort = "18";
        } else {
            // 完全一致を優先して、部分一致もチェック
            for (const pageFilter of codeMaster.page_filter) {
                if (pageFilter.code_display) {
                    // 完全一致を最優先
                    if (tableName === pageFilter.code_display) {
                        pageSort = pageFilter.sort_column;
                        break;
                    }
                    // 完全一致がない場合の部分一致（pageSortがまだ設定されていない場合のみ）
                    if (pageSort === null && tableName.includes(pageFilter.code_display)) {
                        pageSort = pageFilter.sort_column;
                    }
                }
            }
        }

        // column_sortの取得
        let columnSort = null;
        tableNameMaster.map((row: any) => {
            if (row.table_physics_name === item.target_table && 
                row.column_physics_name === item.target_column) {
                columnSort = row.sort_column;
            }
        });

        // page_sortとcolumn_sortを追加したアイテムを返す
        return {
            ...item,
            page_sort: pageSort,
            column_sort: columnSort
        };
    });
};

// フィルタオプションを生成する関数
export const generateFilterOptions = (data: any[], codeMaster: any) => {
    // 修正者の重複除去とソート（昇順）
    const editorsSet = new Set(data.map((item: any) => item.update_name).filter(Boolean));
    
    // 枝の重複除去とソート（昇順）
    const branchesSet = new Set(data.map((item: any) => item.branch).filter(Boolean));
    
    // ページフィルタ：codeMaster.page_filter を sort_column で並び替え
    const pages = codeMaster?.page_filter?.sort((a: any, b: any) => (a.sort_column || 0) - (b.sort_column || 0)) || [];
    
    return {
        editors: Array.from(editorsSet).sort(), // Set → 配列変換 → 昇順ソート
        branches: Array.from(branchesSet).sort(), // Set → 配列変換 → 昇順ソート
        pages: pages, // sort_column順で並び替え済み
    };
};

// フィルタを適用する関数
// パフォーマンス最適化：事前計算されたtableLogicNameを使用
export const applyFilter = (data: any[], filters: FilterCriteria) => {
    let filteredData = data.slice();

    // 日付フィルタ
    // 開始日が設定されている場合：その日以降（その日を含む）のデータを表示
    if (filters.startDate) {
        filteredData = filteredData.filter((item: any) => {
            const dayjs = require("dayjs");
            const itemDate = dayjs(item.publish_time);
            return itemDate.isAfter(filters.startDate) || itemDate.isSame(filters.startDate, "day");
        });
    }

    // 終了日が設定されている場合：その日以前（その日を含む）のデータを表示
    if (filters.endDate) {
        filteredData = filteredData.filter((item: any) => {
            const dayjs = require("dayjs");
            const itemDate = dayjs(item.publish_time);
            return itemDate.isBefore(filters.endDate) || itemDate.isSame(filters.endDate, "day");
        });
    }

    // 修正者フィルタ（複数選択対応）
    if (filters.editor && filters.editor.length > 0) {
        filteredData = filteredData.filter((item: any) => 
            filters.editor.includes(item.update_name)
        );
    }

    // 枝フィルタ（複数選択対応）
    if (filters.branch && filters.branch.length > 0) {
        filteredData = filteredData.filter((item: any) => 
            filters.branch.includes(item.branch)
        );
    }

    // ページフィルタ（複数選択対応）- 事前計算されたtableLogicNameを使用
    if (filters.page && filters.page.length > 0) {
        filteredData = filteredData.filter((item: any) => {
            // 事前計算されたtableLogicNameを使用
            const tableName = item.tableLogicName;
            // 選択されたページのいずれかがtableNameに含まれているかチェック
            return filters.page.some((selectedPage: string) => tableName.includes(selectedPage));
        });
    }

    return filteredData;
};


// 共通のヘルパー関数

/**
 * 項目グループの集約データを取得する関数
 * 複数のレコードから適切な値を選択して項目グループヘッダーに表示するためのデータを生成
 * 
 * @param items - 同一項目に属するデータアイテムの配列
 * @returns 集約されたデータオブジェクト（null の場合は空配列）
 */
export const getItemGroupSummary = (items: any[]) => {
    if (!items || items.length === 0) return null;
    
    // 日付でソート（古い順）- publish_timeを基準に時系列順に並べる
    const sortedItems = [...items].sort((a, b) => 
        new Date(a.publish_time).getTime() - new Date(b.publish_time).getTime()
    );
    
    return {
        oldestRecord: sortedItems[0],                          // 一番古いレコード（変更前の値用）
        newestRecord: sortedItems[sortedItems.length - 1],     // 一番新しいレコード（変更後の値用）
        latestRecord: sortedItems[sortedItems.length - 1]      // 最新レコード（変更内容用）
    };
};

/**
 * オブジェクトのキーを指定された順序でソートして新しいオブジェクトを作成する汎用関数
 * 
 * JavaScriptのオブジェクトは数値文字列のキー（"1", "2", "3"など）を自動的に昇順でソートしてしまうため、
 * 手動でキーの順序を制御したい場合にこの関数を使用する。
 * 
 * @param obj - ソート対象のオブジェクト。キーが文字列、値が任意の型Tのオブジェクト
 * @param sortFn - キーをソートするための比較関数。Array.sort()と同じ形式
 *                 (a, b) => number の形で、負の値なら a < b、正の値なら a > b、0なら a = b
 * @returns ソート済みのキー順序で再構築された新しいオブジェクト。元のオブジェクトは変更されない
 * 
 * @example
 * // 枝を降順でソートする例
 * const branches = { "枝1": [item1], "枝3": [item2], "枝2": [item3] };
 * const sorted = sortObjectByKeys(branches, (a, b) => {
 *   const aNum = parseInt(a.replace("枝", ""));
 *   const bNum = parseInt(b.replace("枝", ""));
 *   return bNum - aNum; // 降順: 枝3, 枝2, 枝1
 * });
 * // 結果: { "枝3": [item2], "枝2": [item3], "枝1": [item1] }
 */
const sortObjectByKeys = <T>(obj: {[key: string]: T}, sortFn: (a: string, b: string) => number): {[key: string]: T} => {
    // 1. オブジェクトのキーを配列として取得し、指定された比較関数でソート
    const sortedKeys = Object.keys(obj).sort(sortFn);
    // 2. 新しい空のオブジェクトを作成
    const result: {[key: string]: T} = {};
    // 3. ソート済みのキー順序で、元のオブジェクトから値を取得して新しいオブジェクトに設定
    sortedKeys.forEach(key => {
        result[key] = obj[key];
    });
    return result;
};


/**
 * 階層構造データグループ化関数
 * 4階層ページ（商圏・通行量・競合店・影響度）と通常ページ（3階層）で処理し、
 * 最終的にpage_sort順でソートして返す
 * パフォーマンス最適化：事前計算されたtableLogicNameとcolumnLogicNameを使用
 * 
 * @param data - ソート対象のデータ配列
 * @param tableNameMaster - テーブル名マスターデータ
 * @param codeMaster - コードマスターデータ
 * @returns 階層構造でソートされたデータ（4階層ページ：商圏・通行量・競合店・影響度、3階層ページ：通常ページ）
 */
// コメントデータを変更履歴と同じ構造に変換する関数
export const processCommentsForCombination = (comments: any[], codeMaster: any) => {
    return comments
        .filter((commentItem: any) => commentItem.target_table && !commentItem.target_table.includes("RR内部用")) // RR内部用ページのコメントは変更履歴に表示しない
        .map((commentItem: any) => {
            // page_sortの決定（完全一致のみ）
            const tableName = commentItem.target_table || "コメントページ指定なし";
            let pageSort = null;
            
            if (codeMaster?.page_filter) {
                for (const pageFilter of codeMaster.page_filter) {
                    if (pageFilter.code_display) {
                        if (tableName === pageFilter.code_display) {
                            pageSort = pageFilter.sort_column;
                            break;
                        }
                    }
                }
            }
            
            return {
                ...commentItem,
                tableLogicName: tableName,
                columnLogicName: commentItem.target_column,
                beforeValueDisplay: "",
                afterValueDisplay: commentItem.comment,
                page_sort: pageSort,
                column_sort: -99,
                target_column: "コメント",
                target_before_value: "",
                target_after_value: commentItem.comment
            };
        });
};

export const groupChangeHistoryByItemHierarchy = (data: any[], tableNameMaster: any, codeMaster: any) => {
    // 4階層ページ（商圏・通行量・競合店・影響度）と通常ページ（3階層）の構造を統合
    // 新しい構造: 枝 > ページ > テーブル論理名/項目
    const branchItemGroups: {
        [branchKey: string]: {
            [pageName: string]: {
                [tableLogicNameOrItemKey: string]: any[] | {[itemKey: string]: any[]}
            }
        }
    } = {};
    const pageSortColumns: {[pageName: string]: number} = {};

    // 1回のループで全データを処理（商圏ページ、通行量ページ、競合店ページ、影響度ページ、通常ページを統合処理）
    data.forEach((item: any) => {
        // 商圏ページかどうかを判定
        const isTradeArea = item.target_table === "location_trade_area" || item.page_sort === "8";
        // 通行量ページかどうかを判定
        const isTraffic = item.target_table === "location_traffic" || item.page_sort === "11";
        // 競合店の判定を細分化
        const isConflictOwn = item.page_sort === "16";  // 競合店のみ（3階層）
        const isConflictStore = item.page_sort === "17" || item.page_sort === "18";  // CVS/SMDSのみ（4階層）
        // 影響度ページかどうかを判定
        const isImpact = item.page_sort === "22";
        
        // ページ名設定
        let pageName = "ページなし"; // デフォルト値
        if (isTradeArea) {
            pageName = "商圏";
        } else if (isTraffic) {
            pageName = "通行量";
        } else if (isConflictOwn) {
            pageName = "競合店";
        } else if (isConflictStore) {
            if (item.page_sort === "17") {
                pageName = "競合店（CVS）";
            } else if (item.page_sort === "18") {
                pageName = "競合店（SMDS）";
            }
        } else if (isImpact) {
            pageName = "影響度";
        } else if (item.page_sort && codeMaster?.page_filter) {
            const matchedFilter = codeMaster.page_filter.find((filter: any) => 
                filter.sort_column === item.page_sort
            );
            if (matchedFilter?.code_display) {
                pageName = matchedFilter.code_display;
            }
        }
        
        // 枝キーの生成（数値の自動ソートを防ぐため「枝」プレフィックスを付与）
        const branchKey = `枝${item.branch}`;
        
        // 第1階層（枝レベル）の初期化
        if (!branchItemGroups[branchKey]) {
            branchItemGroups[branchKey] = {};
        }
        
        // 第2階層（ページレベル）の初期化
        if (!branchItemGroups[branchKey][pageName]) {
            branchItemGroups[branchKey][pageName] = {};
            pageSortColumns[pageName] = item.page_sort || 99;
        }
        
        if (isTradeArea) {
            // 商圏ページ：4階層処理（枝 > ページ > テーブル論理名 + 町名付き > 項目）
            
            // 第3階層: 事前計算されたテーブル論理名（町名付き）を使用
            const tableLogicName = item.tableLogicName;
            
            // 第4階層: 事前計算された項目名を使用
            const itemName = item.columnLogicName;
            
            // 第3階層（テーブル論理名レベル）の初期化
            if (!branchItemGroups[branchKey][pageName][tableLogicName]) {
                branchItemGroups[branchKey][pageName][tableLogicName] = {};
            }
            
            // 第4階層（項目レベル）の初期化
            const pageItemSubKeyGroups = branchItemGroups[branchKey][pageName][tableLogicName] as {[itemKey: string]: any[]};
            if (!pageItemSubKeyGroups[itemName]) {
                pageItemSubKeyGroups[itemName] = [];
            }
            
            // データの追加
            pageItemSubKeyGroups[itemName].push(item);
            
        } else if (isTraffic) {
            // 通行量ページ：4階層処理（枝 > ページ > テーブル論理名 + traffic_type + traffic_type_seq 行目 > 項目）
            
            // 第3階層: 事前計算されたテーブル論理名（traffic_type + traffic_type_seq付き）を使用
            const tableLogicName = item.tableLogicName;
            
            // 第4階層: 事前計算された項目名を使用
            const itemName = item.columnLogicName;
            
            // 第3階層（テーブル論理名レベル）の初期化
            if (!branchItemGroups[branchKey][pageName][tableLogicName]) {
                branchItemGroups[branchKey][pageName][tableLogicName] = {};
            }
            
            // 第4階層（項目レベル）の初期化
            const pageItemSubKeyGroups = branchItemGroups[branchKey][pageName][tableLogicName] as {[itemKey: string]: any[]};
            if (!pageItemSubKeyGroups[itemName]) {
                pageItemSubKeyGroups[itemName] = [];
            }
            
            // データの追加
            pageItemSubKeyGroups[itemName].push(item);
            
        } else if (isConflictOwn) {
            // 競合店（page_sort="16"）：3階層処理（枝 > ページ > 項目）- コメントのみ
            
            // 第3階層: 事前計算された項目名を使用
            const itemName = item.columnLogicName;
            
            // 第3階層（項目レベル）の初期化
            if (!branchItemGroups[branchKey][pageName][itemName]) {
                branchItemGroups[branchKey][pageName][itemName] = [];
            }
            
            // データの追加
            (branchItemGroups[branchKey][pageName][itemName] as any[]).push(item);
            
        } else if (isConflictStore) {
            // 競合店（CVS/SMDS）ページ：4階層処理（枝 > ページ > 競合店（CVS）/競合店（SMDS） + 店舗名 > 項目）
            
            // 第3階層: 事前計算されたテーブル論理名（店舗名付き）を使用
            const conflictStoreKey = item.tableLogicName;
            
            // 第4階層: 事前計算された項目名を使用
            const itemName = item.columnLogicName;
            
            // 第3階層（競合店舗+店舗名レベル）の初期化
            if (!branchItemGroups[branchKey][pageName][conflictStoreKey]) {
                branchItemGroups[branchKey][pageName][conflictStoreKey] = {};
            }
            
            // 第4階層（項目レベル）の初期化
            const pageItemSubKeyGroups = branchItemGroups[branchKey][pageName][conflictStoreKey] as {[itemKey: string]: any[]};
            if (!pageItemSubKeyGroups[itemName]) {
                pageItemSubKeyGroups[itemName] = [];
            }
            
            // データの追加
            pageItemSubKeyGroups[itemName].push(item);
            
        } else if (isImpact) {
            // 影響度ページのコメントも4階層処理に統一（枝 > ページ > 影響度 > コメント）
            if (item.target_column === "コメント") {
                // コメントデータの場合はシンプルに「影響度」として統一
                // 第3階層のキーを決定
                const impactCommentKey = `影響度`;
                
                // 第3階層の初期化
                if (!branchItemGroups[branchKey][pageName][impactCommentKey]) {
                    branchItemGroups[branchKey][pageName][impactCommentKey] = {};
                }
                
                // 第4階層のキーを決定（項目名）
                const itemKey = item.columnLogicName;
                
                // 第4階層（コメントレベル）の初期化
                const pageItemSubKeyGroups = branchItemGroups[branchKey][pageName][impactCommentKey] as {[itemKey: string]: any[]};
                if (!pageItemSubKeyGroups[itemKey]) {
                    pageItemSubKeyGroups[itemKey] = [];
                }
                
                // データの追加
                pageItemSubKeyGroups[itemKey].push(item);
                
            } else {
                // 通常の影響度データの場合は4階層処理（枝 > ページ > 影響度 + tenpo_name > 個別項目/ルート）
                // 
                // 影響度ページの特殊な構造：
                // - location_impact: 基本項目（店舗名ベース）
                // - location_impact_counter: カウンター項目（ルート・交差点ベース）
                // 
                // 第3階層のキー構造：
                // - location_impact: "影響度\n店舗名"
                // - location_impact_counter: "影響度\n店舗名\nルート名\n交差点名"
                
                // sub_keyからtenpo_name、route、intersectionを取得
                let tenpoName = "";
                let route = "";
                let intersection = "";
                
                try {
                    const subKey = JSON.parse(
                        item.sub_key.includes("'")
                        ? JSON.stringify(item.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                        : item.sub_key
                    );
                    
                    tenpoName = subKey.tenpo_name || "";
                    route = subKey.route || "";
                    intersection = subKey.intersection || "";
                } catch (e) {}
                
                // tenpo_nameが存在する場合のみ処理
                if (tenpoName) {
                    // 第3階層のキーを決定（テーブル別の分離処理）
                    let impactTenpoKey = "";
                    
                    if (item.target_table === "location_impact") {
                        // 基本項目：店舗名のみ
                        impactTenpoKey = `影響度\n${tenpoName}`;
                    } else if (item.target_table === "location_impact_counter") {
                        // カウンター項目：店舗名＋ルート＋交差点
                        impactTenpoKey = `影響度\n${tenpoName}\n${route}\n${intersection}`;
                    }
                    
                    // 第3階層の初期化
                    if (!branchItemGroups[branchKey][pageName][impactTenpoKey]) {
                        branchItemGroups[branchKey][pageName][impactTenpoKey] = {};
                    }
                    
                    // 第4階層のキーを決定（項目名）
                    const itemKey = item.columnLogicName;
                    
                    // 第4階層（個別項目/ルートレベル）の初期化
                    const pageItemSubKeyGroups = branchItemGroups[branchKey][pageName][impactTenpoKey] as {[itemKey: string]: any[]};
                    if (!pageItemSubKeyGroups[itemKey]) {
                        pageItemSubKeyGroups[itemKey] = [];
                    }
                    
                    // データの追加
                    pageItemSubKeyGroups[itemKey].push(item);
                }
            }
            
        } else {
            // 通常ページの場合：3階層処理（枝 > ページ > 項目）
            
            // 第3階層: 事前計算された項目名を使用
            const itemName = item.columnLogicName;
            
            // 第3階層（項目レベル）の初期化
            if (!branchItemGroups[branchKey][pageName][itemName]) {
                branchItemGroups[branchKey][pageName][itemName] = [];
            }
            
            // データの追加
            (branchItemGroups[branchKey][pageName][itemName] as any[]).push(item);
        }
    });
    
    // 各階層のソート処理
    
    // 第1階層: 枝を昇順でソート
    const sortedBranches = sortObjectByKeys(branchItemGroups, (a, b) => {
        const aBranch = a.replace("枝", "");
        const bBranch = b.replace("枝", "");
        return compareBranchValues(aBranch, bBranch); // 昇順
    });
    
    // 第2階層以降のソート処理
    Object.keys(sortedBranches).forEach(branchKey => {
        // 第2階層: ページをpage_sortで昇順ソート
        sortedBranches[branchKey] = sortObjectByKeys(sortedBranches[branchKey], (a, b) => {
            const aPageSort = pageSortColumns[a] || 99;
            const bPageSort = pageSortColumns[b] || 99;
            return aPageSort - bPageSort;
        });
        
        // 第3階層以降のソート処理
        Object.keys(sortedBranches[branchKey]).forEach(pageName => {
            // 商圏ページが存在するのか判定
            const isTradeAreaPage = pageName === "商圏";
            // 通行量ページが存在するのか判定
            const isTrafficPage = pageName === "通行量";
            // 競合店ページが存在するのか判定
            const isConflictStorePage = pageName === "競合店（CVS）" || pageName === "競合店（SMDS）";
            // 影響度ページが存在するのか判定
            const isImpactPage = pageName === "影響度";
            
            if (isTradeAreaPage) {
                // 商圏ページの場合：4階層ソート
                
                // 第3階層: テーブル論理名を文字列順でソート
                sortedBranches[branchKey][pageName] = sortObjectByKeys(sortedBranches[branchKey][pageName], (a, b) => {
                    return a.localeCompare(b, "ja"); // 日本語対応の文字列比較
                });
                
                // 第4階層: 項目をtrade_area_seq昇順 → column_sort昇順でソート
                Object.keys(sortedBranches[branchKey][pageName]).forEach(tableLogicName => {
                    const pageItemSubKeyGroups = sortedBranches[branchKey][pageName][tableLogicName] as {[itemKey: string]: any[]};
                    sortedBranches[branchKey][pageName][tableLogicName] = sortObjectByKeys(
                        pageItemSubKeyGroups, 
                        (a, b) => {
                            const aItems = pageItemSubKeyGroups[a];
                            const bItems = pageItemSubKeyGroups[b];
                            
                            if (aItems.length === 0 && bItems.length === 0) return 0;
                            if (aItems.length === 0) return 1;
                            if (bItems.length === 0) return -1;
                            
                            const aItem = aItems[0];
                            const bItem = bItems[0];
                            
                            // 第1優先: trade_area_seq昇順でソート
                            let aTradeAreaSeq = 99;
                            let bTradeAreaSeq = 99;
                            
                            // aItemのtrade_area_seqを取得
                            if (aItem.sub_key) {
                                try {
                                    const aSubKey = JSON.parse(
                                        aItem.sub_key.includes("'")
                                        ? JSON.stringify(aItem.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                                        : aItem.sub_key
                                    );
                                    if (aSubKey && "trade_area_seq" in aSubKey) {
                                        const seq = parseInt(aSubKey.trade_area_seq);
                                        aTradeAreaSeq = isNaN(seq) ? 99 : seq;
                                    }
                                } catch (e) {
                                    // JSON解析エラーの場合はデフォルト値を使用
                                }
                            }
                            // 直接フィールドからの取得を試行
                            if (aItem.trade_area_seq !== undefined && aItem.trade_area_seq !== null) {
                                const seq = parseInt(aItem.trade_area_seq);
                                aTradeAreaSeq = isNaN(seq) ? 99 : seq;
                            }
                            
                            // bItemのtrade_area_seqを取得
                            if (bItem.sub_key) {
                                try {
                                    const bSubKey = JSON.parse(
                                        bItem.sub_key.includes("'")
                                        ? JSON.stringify(bItem.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                                        : bItem.sub_key
                                    );
                                    if (bSubKey && "trade_area_seq" in bSubKey) {
                                        const seq = parseInt(bSubKey.trade_area_seq);
                                        bTradeAreaSeq = isNaN(seq) ? 99 : seq;
                                    }
                                } catch (e) {
                                    // JSON解析エラーの場合はデフォルト値を使用
                                }
                            }
                            // 直接フィールドからの取得を試行
                            if (bItem.trade_area_seq !== undefined && bItem.trade_area_seq !== null) {
                                const seq = parseInt(bItem.trade_area_seq);
                                bTradeAreaSeq = isNaN(seq) ? 99 : seq;
                            }
                            
                            if (aTradeAreaSeq !== bTradeAreaSeq) {
                                return aTradeAreaSeq - bTradeAreaSeq;
                            }
                            
                            // 第2優先: column_sort昇順でソート
                            const aColumnSort = (aItem && aItem.column_sort !== undefined && aItem.column_sort !== null) ? parseInt(aItem.column_sort) || 99 : 99;
                            const bColumnSort = (bItem && bItem.column_sort !== undefined && bItem.column_sort !== null) ? parseInt(bItem.column_sort) || 99 : 99;
                            return aColumnSort - bColumnSort;
                        }
                    );
                });
                
            } else if (isTrafficPage) {
                // 通行量ページの場合：4階層ソート
                
                // 第3階層: コメントを先頭に、その後にテーブル論理名をtraffic_type昇順 → traffic_type_seqの有無 → traffic_type_seq昇順でソート
                sortedBranches[branchKey][pageName] = sortObjectByKeys(sortedBranches[branchKey][pageName], (a, b) => {
                    // 各テーブル論理名グループから最初のアイテムを取得してsub_keyを解析
                    const aItems = Object.values(sortedBranches[branchKey][pageName][a] as {[itemKey: string]: any[]})[0];
                    const bItems = Object.values(sortedBranches[branchKey][pageName][b] as {[itemKey: string]: any[]})[0];
                    
                    if (!aItems || aItems.length === 0 || !bItems || bItems.length === 0) {
                        return a.localeCompare(b, "ja"); // フォールバック: 文字列比較
                    }
                    
                    const aItem = aItems[0];
                    const bItem = bItems[0];
                    
                    // コメントかどうかを判定
                    const aIsComment = aItem && aItem.target_column === "コメント";
                    const bIsComment = bItem && bItem.target_column === "コメント";
                    
                    // コメントを最初に表示
                    if (aIsComment !== bIsComment) {
                        return aIsComment ? -1 : 1; // aがコメントなら先頭に
                    }
                    
                    // 両方ともコメントの場合は文字列比較
                    if (aIsComment && bIsComment) {
                        return a.localeCompare(b, "ja");
                    }
                    
                    // sub_keyからtraffic_typeとtraffic_type_seqを取得
                    let aTrafficType = 99, aTrafficTypeSeq = null, aHasTrafficTypeSeq = false;
                    let bTrafficType = 99, bTrafficTypeSeq = null, bHasTrafficTypeSeq = false;
                    
                    try {
                        const aSubKey = JSON.parse(
                            aItem.sub_key.includes("'")
                            ? JSON.stringify(aItem.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                            : aItem.sub_key
                        );
                        if (aSubKey.traffic_type !== undefined) {
                            const parsed = parseInt(aSubKey.traffic_type);
                            aTrafficType = isNaN(parsed) ? 99 : parsed;
                        }
                        if (aSubKey.traffic_type_seq !== undefined && aSubKey.traffic_type_seq !== null) {
                            aTrafficTypeSeq = parseInt(aSubKey.traffic_type_seq) || 99;
                            aHasTrafficTypeSeq = true;
                        }
                    } catch (e) {
                        // JSON解析エラーの場合はデフォルト値を使用
                    }
                    
                    try {
                        const bSubKey = JSON.parse(
                            bItem.sub_key.includes("'")
                            ? JSON.stringify(bItem.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                            : bItem.sub_key
                        );
                        if (bSubKey.traffic_type !== undefined) {
                            const parsed = parseInt(bSubKey.traffic_type);
                            bTrafficType = isNaN(parsed) ? 99 : parsed;
                        }
                        if (bSubKey.traffic_type_seq !== undefined && bSubKey.traffic_type_seq !== null) {
                            bTrafficTypeSeq = parseInt(bSubKey.traffic_type_seq) || 99;
                            bHasTrafficTypeSeq = true;
                        }
                    } catch (e) {
                        // JSON解析エラーの場合はデフォルト値を使用
                    }
                    
                    // 第1優先: traffic_type昇順でソート
                    if (aTrafficType !== bTrafficType) {
                        return aTrafficType - bTrafficType;
                    }
                    
                    // 第2優先: traffic_type_seqの有無でソート（存在しないものを先に表示）
                    if (aHasTrafficTypeSeq !== bHasTrafficTypeSeq) {
                        return aHasTrafficTypeSeq ? 1 : -1; // falseが先（traffic_type_seqが存在しないもの）
                    }
                    
                    // 第3優先: traffic_type_seq昇順でソート（両方ともtraffic_type_seqが存在する場合のみ）
                    if (aHasTrafficTypeSeq && bHasTrafficTypeSeq && aTrafficTypeSeq !== null && bTrafficTypeSeq !== null) {
                        return aTrafficTypeSeq - bTrafficTypeSeq;
                    }
                    
                    return 0;
                });
                
                // 第4階層: 項目をcolumn_sort昇順でソート
                Object.keys(sortedBranches[branchKey][pageName]).forEach(tableLogicName => {
                    const pageItemSubKeyGroups = sortedBranches[branchKey][pageName][tableLogicName] as {[itemKey: string]: any[]};
                    sortedBranches[branchKey][pageName][tableLogicName] = sortObjectByKeys(
                        pageItemSubKeyGroups, 
                        (a, b) => {
                            const aItems = pageItemSubKeyGroups[a];
                            const bItems = pageItemSubKeyGroups[b];
                            
                            if (aItems.length === 0 && bItems.length === 0) return 0;
                            if (aItems.length === 0) return 1;
                            if (bItems.length === 0) return -1;
                            
                            const aItem = aItems[0];
                            const bItem = bItems[0];
                            
                            // column_sort昇順でソート
                            const aColumnSort = (aItem && aItem.column_sort !== undefined && aItem.column_sort !== null) ? parseInt(aItem.column_sort) || 99 : 99;
                            const bColumnSort = (bItem && bItem.column_sort !== undefined && bItem.column_sort !== null) ? parseInt(bItem.column_sort) || 99 : 99;
                            return aColumnSort - bColumnSort;
                        }
                    );
                });
                
            } else if (isConflictStorePage) {
                // 競合店ページの場合：4階層ソート
                
                // 第3階層: 競合店舗+店舗名を文字列順でソート
                sortedBranches[branchKey][pageName] = sortObjectByKeys(sortedBranches[branchKey][pageName], (a, b) => {
                    return a.localeCompare(b, "ja"); // 日本語対応の文字列比較
                });
                
                // 第4階層: 項目をcolumn_sort昇順でソート
                Object.keys(sortedBranches[branchKey][pageName]).forEach(conflictStoreKey => {
                    const pageItemSubKeyGroups = sortedBranches[branchKey][pageName][conflictStoreKey] as {[itemKey: string]: any[]};
                    sortedBranches[branchKey][pageName][conflictStoreKey] = sortObjectByKeys(
                        pageItemSubKeyGroups, 
                        (a, b) => {
                            const aItems = pageItemSubKeyGroups[a];
                            const bItems = pageItemSubKeyGroups[b];
                            
                            if (aItems.length === 0 && bItems.length === 0) return 0;
                            if (aItems.length === 0) return 1;
                            if (bItems.length === 0) return -1;
                            
                            const aItem = aItems[0];
                            const bItem = bItems[0];
                            
                            // column_sort昇順でソート
                            const aColumnSort = (aItem && aItem.column_sort !== undefined && aItem.column_sort !== null) ? parseInt(aItem.column_sort) || 99 : 99;
                            const bColumnSort = (bItem && bItem.column_sort !== undefined && bItem.column_sort !== null) ? parseInt(bItem.column_sort) || 99 : 99;
                            return aColumnSort - bColumnSort;
                        }
                    );
                });
                
            } else if (isImpactPage) {
                // 影響度ページの場合：4階層ソート（枝 > ページ > tenpo_name > 個別項目/ルート）
                // 
                // 影響度ページのソート処理：
                // 1. 第3階層: tenpo_name（店舗名）昇順
                // 2. 第4階層: location_impact（基本項目）→ location_impact_counter（カウンター項目）の順
                // 3. location_impact_counterの場合はroute_seq順序でソート
                
                // 第3階層: tenpo_name昇順でソート
                sortedBranches[branchKey][pageName] = sortObjectByKeys(sortedBranches[branchKey][pageName], (a, b) => {
                    return a.localeCompare(b, "ja"); // tenpo_name昇順
                });
                
                // 第4階層: 個別項目/ルートをソート（項目とroute+intersectionを混在）
                Object.keys(sortedBranches[branchKey][pageName]).forEach(tenpoName => {
                    const pageItemSubKeyGroups = sortedBranches[branchKey][pageName][tenpoName] as {[itemKey: string]: any[]};
                    sortedBranches[branchKey][pageName][tenpoName] = sortObjectByKeys(
                        pageItemSubKeyGroups, 
                        (a, b) => {
                            const aItems = pageItemSubKeyGroups[a];
                            const bItems = pageItemSubKeyGroups[b];
                            
                            if (aItems.length === 0 && bItems.length === 0) return 0;
                            if (aItems.length === 0) return 1;
                            if (bItems.length === 0) return -1;
                            
                            const aItem = aItems[0];
                            const bItem = bItems[0];
                            
                            // target_tableで分類（影響度特有の処理）
                            const aIsImpactCounter = aItem.target_table === "location_impact_counter";
                            const bIsImpactCounter = bItem.target_table === "location_impact_counter";
                            
                            // location_impact（基本項目）を先に、location_impact_counter（カウンター項目）を後に表示
                            if (aIsImpactCounter !== bIsImpactCounter) {
                                return aIsImpactCounter ? 1 : -1; // falseが先（location_impactが先）
                            }
                            
                            if (aIsImpactCounter && bIsImpactCounter) {
                                // 両方ともlocation_impact_counterの場合
                                // 第1優先: route_seqで昇順ソート
                                let aRouteSeq = 99, bRouteSeq = 99;
                                
                                try {
                                    const aSubKey = JSON.parse(
                                        aItem.sub_key.includes("'")
                                        ? JSON.stringify(aItem.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                                        : aItem.sub_key
                                    );
                                    aRouteSeq = aSubKey.route_seq ? parseInt(aSubKey.route_seq) : 99;
                                } catch (e) {}
                                
                                try {
                                    const bSubKey = JSON.parse(
                                        bItem.sub_key.includes("'")
                                        ? JSON.stringify(bItem.sub_key).replaceAll('"', '').replaceAll("'", '\"')
                                        : bItem.sub_key
                                    );
                                    bRouteSeq = bSubKey.route_seq ? parseInt(bSubKey.route_seq) : 99;
                                } catch (e) {}
                                
                                if (aRouteSeq !== bRouteSeq) {
                                    return aRouteSeq - bRouteSeq;
                                }
                                
                                // 第2優先: column_sortで昇順ソート
                                const aColumnSort = (aItem && aItem.column_sort !== undefined && aItem.column_sort !== null) ? parseInt(aItem.column_sort) || 99 : 99;
                                const bColumnSort = (bItem && bItem.column_sort !== undefined && bItem.column_sort !== null) ? parseInt(bItem.column_sort) || 99 : 99;
                                return aColumnSort - bColumnSort;
                            } else {
                                // 両方ともlocation_impact（基本項目）の場合：column_sort昇順でソート
                                const aColumnSort = (aItem && aItem.column_sort !== undefined && aItem.column_sort !== null) ? parseInt(aItem.column_sort) : 99;
                                const bColumnSort = (bItem && bItem.column_sort !== undefined && bItem.column_sort !== null) ? parseInt(bItem.column_sort) : 99;
                                return aColumnSort - bColumnSort;
                            }
                        }
                    );
                });
                
            } else {
                // 通常ページの場合：3階層ソート
                
                // 第3階層: 項目をcolumn_sortで昇順ソート
                sortedBranches[branchKey][pageName] = sortObjectByKeys(sortedBranches[branchKey][pageName], (a, b) => {
                    const aItems = sortedBranches[branchKey][pageName][a] as any[];
                    const bItems = sortedBranches[branchKey][pageName][b] as any[];
                    const aColumnSort = aItems.length > 0 ? (parseInt(aItems[0].column_sort) || 99) : 99;
                    const bColumnSort = bItems.length > 0 ? (parseInt(bItems[0].column_sort) || 99) : 99;
                    return aColumnSort - bColumnSort;
                });
            }
        });
    });

    return sortedBranches;
};
